import UsersIcon from "@assets/svg/UsersIcon";
import { RootState } from "@store/reducers";
import { useSelector } from "react-redux";
import RecentActivity from "./components/RecentActivity";
import InterviewMeetingsSection from "./components/InterviewMeetingsSection";
import SwitchAccountSection from "./components/SwitchAccountSection";
import CreditCardIcon from "@assets/svg/CreditCardIcon";
import CheckSquareIcon from "@assets/svg/CheckSquareIcon";
import YourTeamMembers from "./components/YourTeamMembers";
import ExportArrowIcon from "@assets/svg/ExportArrowIcon";
import LatestApplications from "./components/LatestApplications";
import UpcomingInterviews from "./components/UpcomingInterviews";
import RecentJobPosts from "./components/RecentJobPosts";

const stats = [
  {
    label: "Active job posts",
    value: 56,
    icon: <CheckSquareIcon className="w-8 h-8" />,
  },
  {
    label: "Successful Placements",
    value: 24,
    icon: <UsersIcon className="w-8 h-8" />,
  },
  {
    label: "Jobs Expiring Soon",
    value: "02",
    icon: <CreditCardIcon className="w-8 h-8" />,
  },
  {
    label: "Pending Payments",
    value: "£5,891",
    icon: <CreditCardIcon className="w-8 h-8" />,
  },
];

const DashboardRecruiterPage = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <div className="flex flex-col flex-1 rounded-md bg-white p-8">
      <div className="flex flex-col gap-1">
        <span className="font-bold text-2xl text-charcoal">
          Welcome back, {user?.firstName} {user?.lastName}!
        </span>
        <span className="text-xs text-light-black font-medium">
          From <span className="font-bold">{user?.companyName} </span>
        </span>
      </div>

      {/* Row 1 */}
      <div className="flex mt-7 gap-8">
        {/* Col 1 */}
        <div className="grid grid-cols-2 w-[55%] rounded-md gap-3">
          {stats?.map((stat) => {
            return (
              <div className="flex gap-3 w-full rounded-md bg-[#F1F5F9] py-5 pl-5 relative">
                <div className="flex items-center justify-center w-14 h-14 rounded-md bg-white">
                  {stat?.icon}
                </div>
                <div className="flex flex-col justify-between py-1">
                  <span className="font-medium text-xs text-charcoal">
                    {stat?.label}
                  </span>
                  <span className="font-bold">{stat?.value}</span>
                </div>
                <button className="absolute right-1.5 bottom-1.5 hover:bg-blue-100 rounded-md p-1">
                  <ExportArrowIcon className={"w-4 h-4"} />
                </button>
              </div>
            );
          })}
        </div>
        {/* Col 2 */}
        <div className="w-[45%] rounded-md bg-light-white-700 p-2 gap-3 flex flex-col">
          <YourTeamMembers />
        </div>
      </div>

      {/* Row 2 */}
      <div className="flex mt-8 gap-8 min-h-0 flex-1">
        <LatestApplications />
        <UpcomingInterviews />
      </div>
      {/* Row 2 */}
      <div className="flex mt-8 gap-8 min-h-0 flex-1">
        <RecentJobPosts />
        <UpcomingInterviews />
      </div>
    </div>
  );
};

export default DashboardRecruiterPage;
